import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FlagIcon } from '@heroicons/react/24/outline';
import api from '../../services/api';

// Signaler un projet à l'équipe de modération (un signalement par personne et par projet).
const MOTIFS = [
  { value: 'arnaque', label: 'Arnaque ou fraude' },
  { value: 'interdit', label: 'Activité interdite' },
  { value: 'choquant', label: 'Contenu choquant ou offensant' },
  { value: 'faux', label: 'Projet trompeur' },
  { value: 'autre', label: 'Autre raison' },
];

const ReportProjectButton = ({ projectId }) => {
  const [open, setOpen] = useState(false);
  const [motif, setMotif] = useState('arnaque');
  const [details, setDetails] = useState('');
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await api.post(`/projects/${projectId}/report`, { motif, details: details.trim().slice(0, 1000) });
      toast.success("Merci, le projet sera examiné par l'équipe de modération.");
      setOpen(false);
      setDetails('');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Signalement impossible. Réessayez.');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)}
        className="w-full flex items-center justify-center text-sm text-gray-500 hover:text-red-600 hover:underline py-1">
        <FlagIcon className="h-4 w-4 mr-1" /> Signaler ce projet
      </button>
      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <form onSubmit={submit} className="bg-white rounded-xl p-6 w-full max-w-md space-y-4">
            <h3 className="text-lg font-semibold text-text">Signaler le projet</h3>
            <fieldset className="space-y-2">
              <legend className="text-sm font-medium text-gray-700 mb-1">Pourquoi ?</legend>
              {MOTIFS.map((m) => (
                <label key={m.value} className="flex items-center gap-2 text-sm text-gray-700">
                  <input type="radio" name="motif" value={m.value} checked={motif === m.value} onChange={() => setMotif(m.value)} />
                  {m.label}
                </label>
              ))}
            </fieldset>
            <textarea value={details} onChange={(e) => setDetails(e.target.value)} maxLength={1000} rows={3}
              placeholder="Précisions (facultatif)"
              className="w-full border border-gray-300 rounded-lg p-2 text-sm focus:ring-2 focus:ring-primary-500" />
            <p className="text-xs text-gray-500">Le porteur du projet ne saura pas qui l'a signalé.</p>
            <div className="flex justify-end gap-2">
              <button type="button" onClick={() => setOpen(false)} className="px-4 py-2 text-sm rounded-lg border border-gray-300">Annuler</button>
              <button type="submit" disabled={sending} className="px-4 py-2 text-sm rounded-lg bg-red-600 text-white disabled:opacity-50">
                {sending ? 'Envoi…' : 'Envoyer'}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default ReportProjectButton;
